import {Injectable} from '@angular/core';
import {ReadyStateEvent, SSE} from 'sse.js';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SseService {
	createSSEObservable<T>(source: SSE): Observable<T> {
		return new Observable((observer) => {
			const messageHandler = (event: MessageEvent) => {
				try {
					const data = JSON.parse(event.data) as T;
					observer.next(data);
				} catch (err) {
					observer.error(err);
				}
			};
			const openHandler = (event: { headers: { [key: string]: string[] } }) => {
				const headers = normalizeHeaders(event.headers);
				observer.next([[], 'init', { thread_id: headers['thread_id'] ?? '' }] as T);
			};
			const errorHandler = () => {
				observer.error(new Error('SSE connection error'));
			};
			const abortHandler = () => {
				observer.complete();
			};
			const closeHandler = (event: ReadyStateEvent) => {
				if (event.readyState === 2) abortHandler();
			};

			source.addEventListener('open', openHandler);
			source.addEventListener('message', messageHandler);
			source.addEventListener('error', errorHandler);
			source.addEventListener('abort', abortHandler);
			source.addEventListener('readystatechange', closeHandler);

			source.stream();

			return () => {
				source.removeEventListener('open', openHandler);
				source.removeEventListener('message', messageHandler);
				source.removeEventListener('error', errorHandler);
				source.removeEventListener('abort', abortHandler);
				source.removeEventListener('readystatechange', closeHandler);
				source.close();
			};
		});
	}
}

const normalizeHeaders = (headersMap: { [key: string]: string[] }): Record<string, string> => {
	const result: Record<string, string> = {};
	for (const [key, values] of Object.entries(headersMap)) {
		result[key] = values[0];
	}
	return result;
};
